<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
  <div class="no-field-space">
    <form [formGroup]="form">
      <sc-flex>

        <sc-date-field formControlName="dateFrom" [label]="'from'| translate:['tmc-visit.reporting.visitor-export.filter.from',
              translationService.language]" [required]="true">
        </sc-date-field>

        <sc-content-spacer></sc-content-spacer>

        <sc-date-field formControlName="dateUntil" [label]="'to'| translate:['tmc-visit.reporting.visitor-export.filter.to',
              translationService.language]" [required]="true">
        </sc-date-field>

        <sc-content-spacer></sc-content-spacer>

        <button (click)="updateList()" [disabled]="isUpdateListDisabled()" mat-stroked-button>
          {{'show'| translate:['tmc-visit.reporting.visitor-export.action.show',
          translationService.language]}}</button>

        <sc-content-spacer></sc-content-spacer>

        <button (click)="createExcel()" [disabled]="isCreateDisabled()" mat-flat-button>
          {{'export'| translate:['tmc-visit.reporting.visitor-export.action.export',
          translationService.language]}}</button>

      </sc-flex>
    </form>
  </div>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <sc-flex-fitting-content [vertical]="true">
    <sc-content-area [fitHeight]="true">
      <sc-scroll-pane>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>
              {{'id'| translate:['tmc-visit.reporting.visitor-export.id',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.id}} </td>
          </ng-container>

          <!-- Reservation Column -->
          <ng-container matColumnDef="reservation">
            <th mat-header-cell *matHeaderCellDef>
              {{'reservation'|
              translate:['tmc-visit.reporting.visitor-export.reservation', translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.reservation}} </td>
          </ng-container>

          <!-- VisitStatus Column -->
          <ng-container matColumnDef="visitStatus">
            <th mat-header-cell *matHeaderCellDef>
              {{'visitStatus'|
              translate:['tmc-visit.reporting.visitor-export.visit-status', translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.visitStatus |
              translate:['tmc-visit.entity.visit.visit-status.'+ visitor.visitStatus, translationService.language]}}
            </td>
          </ng-container>

          <!-- Arrival Column -->
          <ng-container matColumnDef="arrival">
            <th mat-header-cell *matHeaderCellDef>
              {{'arrival'| translate:['tmc-visit.reporting.visitor-export.arrival',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.arrival}} </td>
          </ng-container>

          <!-- NumberPlate Column -->
          <ng-container matColumnDef="numberPlate">
            <th mat-header-cell *matHeaderCellDef>
              {{'numberPlate'|
              translate:['tmc-visit.reporting.visitor-export.number-plate', translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.numberPlate}} </td>
          </ng-container>

          <!-- Reason Column -->
          <ng-container matColumnDef="reason">
            <th mat-header-cell *matHeaderCellDef>
              {{'reason'| translate:['tmc-visit.reporting.visitor-export.reason',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.reason}} </td>
          </ng-container>

          <!-- Notes Column -->
          <ng-container matColumnDef="notes">
            <th mat-header-cell *matHeaderCellDef>
              {{'notes'| translate:['tmc-visit.reporting.visitor-export.notes',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.notes}} </td>
          </ng-container>

          <!-- Company Column -->
          <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef>
              {{'company'| translate:['tmc-visit.reporting.visitor-export.company',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.company}} </td>
          </ng-container>

          <!-- FirstName Column -->
          <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef>
              {{'firstName'|
              translate:['tmc-visit.reporting.visitor-export.first-name', translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.firstname}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              {{'name'| translate:['tmc-visit.reporting.visitor-export.name',
              translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.name}} </td>
          </ng-container>

          <!-- InRegularIntervals Column -->
          <ng-container matColumnDef="inRegularIntervals">
            <th mat-header-cell *matHeaderCellDef>
              {{'inRegularIntervals'|
              translate:['tmc-visit.reporting.visitor-export.in-regular-intervals', translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.inRegularIntervals}} </td>
          </ng-container>

          <!-- RegistrationCode Column -->
          <ng-container matColumnDef="registrationCode">
            <th mat-header-cell *matHeaderCellDef>
              {{'registrationCode'|
              translate:['tmc-visit.reporting.visitor-export.registration-code', translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.registrationCode}} </td>
          </ng-container>

          <!-- RegistrationCode Column -->
          <ng-container matColumnDef="groupMembers">
            <th mat-header-cell *matHeaderCellDef>
              {{'group members'|
              translate:['tmc-visit.reporting.visitor-export.group-members', translationService.language]}}
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.groupMembers}} </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let visitor; columns: columnsToDisplay"></tr>
        </table>
      </sc-scroll-pane>
    </sc-content-area>

  </sc-flex-fitting-content>

</sc-flex>